import React from 'react';
import AppSettingsContext from '../context.js';
import * as u from '../utils.js'

/*---------------------------------------------*/

export default class BaseLayout extends React.Component {
	static contextType = AppSettingsContext;

	constructor() {
		super();
		
		this.container = React.createRef();
		this.updateLayout = this.updateLayout.bind(this);

		this.setElementsStyle = this.setElementsStyle.bind(this);
		this.alignElementsHeight = this.alignElementsHeight.bind(this);
		this.alignElementsTop = this.alignElementsTop.bind(this);
		this.alignElementsSizeBottom = this.alignElementsSizeBottom.bind(this);
	}

	updateLayout() {
		this.alignElementsSizeBottom();
		this.alignElementsHeight();
		this.alignElementsTop();
		u.dispatchEvent(this.container.current,'content-changed');
	}
	
	setElementsStyle(elements,prop,value) {
		elements.forEach((el) => (el.style[prop] = value));
	}

	alignElementsHeight() {
		let container = this.container.current;
		if (!container) // may be we've switched layouts and the container is null
			return;

		let prevItems = Array.from(container.querySelectorAll("[height-aligned]"));
		this.setElementsStyle(prevItems,'min-height','');
		prevItems.forEach((el) => (el.removeAttribute('height-aligned')));

		let items = Array.from(container.querySelectorAll("[align-group]"));
		let alignGroups = {};
		items.forEach((item,index) => {
			let groupId = item.getAttribute('align-group');
			alignGroups[groupId] = alignGroups[groupId] || [];
			alignGroups[groupId].push(item);
		});
		
		// align elements in the order of group ID; highest number is aligned first, lowest last.
		Object.keys(alignGroups).sort((a,b) => b-a).forEach(id => {
			// setTimeout(() => {
				let groupItems = alignGroups[id];
				let maxHeight = groupItems.reduce((max_height,el) => Math.max(max_height,el.offsetHeight),0);
				this.setElementsStyle(groupItems,'min-height',maxHeight+'px');
				groupItems.forEach((el) => (el.setAttribute('height-aligned',true)));
			// });
		});
	}

	alignElementsSizeBottom() {
		let container = this.container.current;
		if (!container) // may be we've switched layouts and the container is null
			return;

		let items = Array.from(container.querySelectorAll("[align-size-bottom]"));
		let alignGroups = {};
		items.forEach((item,index) => {
			let groupId = item.getAttribute('align-size-bottom');
			alignGroups[groupId] = alignGroups[groupId] || [];
			alignGroups[groupId].push(item);
		});

		// align elements in the order of group ID; highest number is aligned first, lowest last.
		Object.keys(alignGroups).sort((a,b) => b-a).forEach(id => {
			setTimeout(() => {
				let groupItems = alignGroups[id];
				this.setElementsStyle(groupItems,'min-height','');

				let maxBottom = groupItems.reduce((value,el) => Math.max(value,el.getBoundingClientRect().top+el.offsetHeight),0);
			
				groupItems.forEach((el) => (el.style.minHeight = (maxBottom-el.getBoundingClientRect().top)+'px'));
			});
		});
	}

	alignElementsTop() {
		let resetGroup = (groupItems) => {
			groupItems.forEach((el) => {
				let hasCustomMargin = el.style.marginTop.indexOf('.01px') !== -1;
				if (hasCustomMargin) {
					el.style.marginTop = el.getAttribute('margin-top-prev');
				} else {
					el.setAttribute('margin-top-prev',el.style.marginTop);
				}
			});
		}
	
		let alignGroup = (groupItems) => {
			let maxTop = groupItems.reduce((value,el) => Math.max(value,el.getBoundingClientRect().top),0);
			groupItems.forEach((el) => {
				let computedStyle = getComputedStyle(el);
				let current = 1*computedStyle.getPropertyValue('margin-top').replace('px','');
				let prevSibling = el.previousElementSibling;
				let sibling = 0;
				if (prevSibling) {
					let prevComputedStyle = getComputedStyle(el.previousElementSibling);
					let elDisplay = computedStyle.getPropertyValue('display');
					let prevDisplay = prevComputedStyle.getPropertyValue('display');
					let parentDisplay = el.parentElement.style.display;
					if (elDisplay === 'block' &&  prevDisplay === 'block' && parentDisplay !== 'inline-grid')
						sibling = 1*prevComputedStyle.getPropertyValue('margin-bottom').replace('px','');
				}

				let top = el.getBoundingClientRect().top;
				if (top < maxTop) {
					let customMargin = Math.round(current + sibling + maxTop - top) + 0.01;
					el.style.marginTop = customMargin+'px';
					// el.style.outline = '1px solid red';
				}
			});
		}

		let container = this.container.current;
		if (!container) // may be we've switched layouts and the container is null
			return;

		let items = Array.from(container.querySelectorAll("[align-top]"));
		let alignGroups = {};
		items.forEach((item,index) => {
			let groupId = 1*item.getAttribute('align-top');
			if (!groupId)
				return;

			alignGroups[groupId] = alignGroups[groupId] || [];
			alignGroups[groupId].push(item);
		});

		let cleanupItems = Array.from(container.querySelectorAll("[margin-top-prev]:not([align-top])"));
		resetGroup(cleanupItems);

		// align elements in the order of group ID; highest number is aligned first, lowest last.
		Object.keys(alignGroups).sort((a,b) => b-a).forEach((id,index) => {
			let groupItems = alignGroups[id];
			resetGroup(groupItems);
			alignGroup(groupItems);
			// setTimeout(() => alignGroup(groupItems));
		});
	}

	componentDidMount() {
		if (this.container && this.container.current && this.container.current.addEventListener) {
			this.container.current.addEventListener("content-changed", (event) => {
				if (this.container.current === event.srcElement)
					return;

				clearTimeout(this.updateDebounce);
				this.updateDebounce = setTimeout(() => this.updateLayout(),100);
			});
		}

		this.updateLayout();
	}

	componentDidUpdate() {
		this.updateLayout();
	}
}